<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.ra_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ra_emname">
            <label class="weui-form-preview__label">{{customLabel.ra_emname || "申请人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{ form.main.ra_emname }}
              <call-mobile :em-id="form.main.ra_emid"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ra_department">
            <label class="weui-form-preview__label">{{customLabel.ra_department || "部门"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.ra_department
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ra_indate">
            <label class="weui-form-preview__label">{{customLabel.ra_indate || "申请日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy年MM月dd'">{{
              form.main.ra_indate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ra_type">
            <label class="weui-form-preview__label">{{customLabel.ra_type || "维保类型"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.ra_type
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ra_urgency">
            <label class="weui-form-preview__label">{{customLabel.ra_urgency || "紧急程度"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.ra_urgency
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ra_device_name">
            <label class="weui-form-preview__label">{{customLabel.ra_device_name || "设备名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.ra_device_name
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ra_device_place">
            <label class="weui-form-preview__label">{{customLabel.ra_device_place || "设备位置"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.ra_device_place
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ra_amount">
            <label class="weui-form-preview__label">{{
              form.main.ra_type == "维修" ? "维修金额" : "保养金额"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ra_amount
            }}</span>
          </div>
          <div class="weui-form-preview__item" style="text-align: left" slot="ra_remark">
            <h4>{{ form.main.ra_type == "维修" ? "故障描述" : "保养描述" }}</h4>
            <div
              style="white-space: pre-line"
              v-html="form.main.ra_remark"
            ></div>
          </div>
        </custom-layout>
      </div>

      <file-list v-model="form.main.ra_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/oa/repair_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CallMobile
  },
  data() {
    return {
      baseUrl: "/api/oa/repairapply",
      codeField: "ra_code",
      statusField: "ra_statuscode",
      caller: "RepairApply",
      xtype:'oa-repairapply-formpanel'
    };
  },
};
</script>